import AlertListContainer from './AlertListContainer';

export default AlertListContainer;
